import { Box } from '@mui/material'
import type { FC } from 'react'
import type { Mission as MissionType } from '../../../MissionService/missionsTypes'
import { CounterOverlay } from './CounterOverlay'

interface MissionProps {
    mission: MissionType
    isClaimable: boolean
}

export const MissionIcon: FC<MissionProps> = ({
    mission: { progress, assetUrl, fallbackAssetUrl, counter, repeatable },
    isClaimable,
}) => {
    const borderColor = isClaimable ? 'secondary.main' : 'common.white'

    return (
        <Box
            className="mission"
            sx={{
                width: '84px',
                height: '84px',
                aspectRatio: '1/1',
                gridArea: 'icon',
                border: '2px solid',
                position: 'relative',
                borderRadius: '6px',
                borderColor,
                overflow: 'hidden',
                backgroundColor: 'background.default',
            }}
        >
            {repeatable && <CounterOverlay value={counter || 1} />}
            {isClaimable && (
                <Box
                    sx={{
                        zIndex: 1,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        backgroundImage: `url(/assets/animations/missions/rays.svg)`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        animation: 'rotate 20s linear infinite',
                        '@keyframes rotate': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(360deg)' },
                        },
                    }}
                />
            )}
            <Box
                className="mission-asset"
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '6px',
                    zIndex: 2,
                    borderRadius: 0,
                    position: 'relative',
                }}
            >
                <img
                    src={assetUrl}
                    onError={(e) => {
                        if (fallbackAssetUrl) {
                            e.currentTarget.src = fallbackAssetUrl
                        }
                    }}
                    alt="Mission icon"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Box>
        </Box>
    )
}
